export enum StatusRetirada {
    APROVADA = 'APROVADA',
    REPROVADA = 'REPROVADA',
    RETIRADA = 'RETIRADA',
    SOLICITADA = 'SOLICITADA',
    FINALIZADA = 'FINALIZADA',
    CANCELADA = 'CANCELADA',
    BAIXADA = 'BAIXADA'
}
